import { State } from '../@types';

export const selectAreas = (store: State) => store.appData.areas;
export const selectDialog = (store: State) => store.appData.common.dialog;
export const selectOpenedModal = (store: State) =>
  store.appData.common.openedModal;
export const selectIsVerifiedUser = (store: State) =>
  store.appData.common.firstSteps;
export const selectBrandSettings = (store: State) =>
  store.appData.common.brandSettings;

export const selectBicMandatory = (store: State) =>
  store.appData.common.brandSettings.bicMandatory;

export const selectAllowedSEPACountries = (store: State) =>
  store.appData.common.brandSettings.allowedSEPACountries;

export const selectCommon = (store: State) => store.appData.common;
export const selectFeatures = (store: State) => store.appData.features;

export const selectIsOBI = (store: State) =>
  store.appData.areas.find((area) =>
    [
      store.ui.map.selectedCar?.areaId,
      store.userData.rental?.rentalData?.carData?.areaId,
    ].includes(area?.id)
  )?.fleetStyle === 'obi';

export const selectIsExpert = (store: State) =>
  store.appData.areas.find((area) =>
    [
      store.ui.map.selectedCar?.areaId,
      store.userData.rental?.rentalData?.carData?.areaId,
    ].includes(area?.id)
  )?.fleetStyle === 'expert';

export const selectIsSPP = (store: State) =>
  store.appData.areas.find((area) =>
    [
      store.ui.map.selectedCar?.areaId,
      store.userData.rental?.rentalData?.carData?.areaId,
    ].includes(area?.id)
  )?.fleetStyle === 'spp';

export const selectIsBUB = (store: State) =>
  store.appData.areas.find((area) =>
    [
      store.ui.map.selectedCar?.areaId,
      store.userData.rental?.rentalData?.carData?.areaId,
    ].includes(area?.id)
  )?.fleetStyle === 'bub';

export const selectFleetStyle = (store: State) =>
  store.appData.areas.find((area) =>
    [
      store.ui.map.selectedCar?.areaId,
      store.userData.rental?.rentalData?.carData?.areaId,
    ].includes(area?.id)
  )?.fleetStyle || 'default';

export const selectSupportContacted = (store: State) =>
  store.appData.common.supportContacted;

export const selectIsIntercomUserRegistered = (store: State) =>
  store.appData.common.isIntercomUserRegistered;

export const selectPois = (store: State) => store.appData.pois;

export const selectServices = (store: State) => store.services;

export const selectServiceTypes = (store: State) => store.appData.serviceTypes;

export const selectTexts = (store: State) => store.appData.texts;
